import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from "./locales/en/translation.json";
import agentRegistration from "./locales/en/agent-registration.json";
import agencyRegistration from "./locales/en/agency-registration.json";
import agentHome from "./locales/en/agent-home.json";
import esTranslations from "./locales/es/translation.json";

const LANGUAGES = {
  EN: "en",
  ES: "es",
};

const detection = {
  order: ["querystring", "navigator"],
  lookupQuerystring: "lng",
};

export const detectLanguage = () => {
  const localLanguage = localStorage.getItem("APP_LANG") ?? LANGUAGES.EN;

  return localLanguage;
};

const brand = process.env.REACT_APP_BRAND || "default";

const applyBrandOverrides = (translations) => {
  const overrides = translations[brand];
  const merged =
    brand !== "default" && overrides && typeof overrides === "object"
      ? { ...translations, ...overrides }
      : { ...translations };

  Object.keys(merged).forEach((key) => {
    if (typeof merged[key] === "object") {
      delete merged[key];
    }
  });

  return merged;
};

const resources = {
  [LANGUAGES.EN]: {
    translation: applyBrandOverrides(enTranslations),
    agentRegistration,
    agencyRegistration,
    agentHome,
  },
  [LANGUAGES.ES]: {
    translation: applyBrandOverrides(esTranslations),
  },
};

const languageDetector = {
  type: "languageDetector",
  detect: () => {
    const lng = detectLanguage();

    return lng;
  },
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    detection,
    resources,
    fallbackLng: LANGUAGES.EN,
    supportedLngs: Object.values(LANGUAGES),
    interpolation: {
      escapeValue: false,
    },
    debug: false,
  });

export default i18n;
